export const EmbeddedConfig = {
  baseUrl:
    process.env.NODE_ENV === 'production'
      ? 'https://app.useindigo.com'
      : 'http://localhost:8000',
};
